<template>
    <button type="button" class="btn btn-primary btn-plan-pago" @click="abrirModal" >
        Ver Plan de pago
    </button>
    <div class="modal fade" id="modalPlanPago" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true" style="padding-inline: 15px !important;">
        <div class="modal-dialog modal-dialog-scrollable modal-xl ">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="staticBackdropLabel">Plan de Pagos</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>

                </div>
                <div class="modal-body">
                    <div id="contenedorTabla">
                        <div class="header d-flex justify-content-between p-3">
                            <h2>Tabla de amortizaciones {{ this.frecuenciaPagoGracia }}</h2>
                            <button @click="handleImprimirPlanPago()" type="button" class="btn btn-success"
                                style="color:white; margin:0;">
                                Exportar Plan De Pago <i class="fa-solid fa-download"></i>
                            </button>
                        </div>
                        <table class="table table-striped table-hover">

                            <thead class="table-dark">
                                <tr>
                                    <th scope="col">No. Cuota</th>
                                    <th scope="col">Fecha de Pago</th>
                                    <th scope="col">Cuota Total</th>
                                    <th scope="col">Interés</th>
                                    <th scope="col">Capital</th>
                                    <th scope="col">Saldo</th>
                                    <th scope="col">Capial DT</th>
                                </tr>
                            </thead>
                            <tbody id="tablaPlanPagos">

                            </tbody>
                        </table>
                        <div id="amortizaciones">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" 
                        >Cerrar</button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jsPDF from 'jspdf';
import * as bootstrap from 'bootstrap'

export default {
    data() {
        return {
            moneda: 'lps',

        };
    },
    props: {
        fechaPago: String,
        monto: Number,
        frecuenciaPago: String,
        interes: Number,
        plazoPago: Number,
        producto: String,
        periodoGracia: Number,
        fechaFija: Boolean,
        pagosInteres: Array,
        frecuenciaPagoGracia: String,
    },

    methods: {
        abrirModal() {
            this.$nextTick(() => {
                const modalElement = document.getElementById('modalPlanPago')
                if (modalElement) {
                    const modal = new bootstrap.Modal(modalElement, {
                        backdrop: 'static',
                        keyboard: false,
                    })
                    modal.show()
                    this.ejecutarPlanPagos()
                } else {
                    console.warn('El modal no está en el DOM todavía.')
                }
            })
        },
        ejecutarPlanPagos() {
            const tablaBody = document.getElementById('tablaPlanPagos')
            const solicitud = {
                fechaPago: this.fechaPago,
                monto: this.monto,
                frecuenciaPago: this.frecuenciaPago,
                interes: this.interes,
                plazoPago: this.plazoPago,
                producto: this.producto,
                periodoGracia: this.periodoGracia,
                frecuenciaPagoGracia: this.frecuenciaPagoGracia,
                fechaFija: this.fechaFija,
                pagosInteres: this.pagosInteres
            }
            if (solicitud.fechaPago === '' || solicitud.monto === '' || solicitud.frecuenciaPago === '' || solicitud.interes === '' || solicitud.plazoPago === '') {
                tablaBody.innerHTML = `
          <tr>
            <td colspan=6 class="text-center text-danger">
              <h3>
                ¡Faltan datos!</td>  
              </h3>
          </tr>
        `
            } else {
                this.generarPlanPago(this.stringToDate(solicitud.fechaPago), solicitud.monto, solicitud.frecuenciaPago, solicitud.interes, solicitud.plazoPago, solicitud.producto, solicitud.periodoGracia, solicitud.fechaFija, solicitud.pagosInteres, solicitud.frecuenciaPagoGracia)
            }
        },
        generarPlanPago(
            fechaApertura,
            monto,
            periodoPago,
            interesAnual,
            plazo,
            producto,
            periodoGracia,
            fechaFijaSolicitud,
            pagosInteres,
            frecuenciaPagoGracia
        ) {
            console.log(frecuenciaPagoGracia);
            let fechaInicial = fechaApertura
            // Calcular la tasa de interés mensual
            let tasaAnual = interesAnual / 100;
            let capitalDT = 0.0;
            let fechaFija = fechaFijaSolicitud

            // Totales
            let SumaCuotaTotal = 0
            let SumaInteres = 0
            let SumaCapital = 0

            // Calcular el intervalo de tiempo entre pagos
            let  interes, capital, saldo;
            
            let cuotaTotal = 0.0;

            saldo = monto;

            // Funcion de caracteristicas del periodo de pago
            const caracteristicas = this.caracteristicasPeriodoPago(periodoPago, fechaFija, producto, plazo, fechaApertura)


            // Generar Cuota Nivelada
            console.log("Plazo", plazo - (periodoGracia*12/caracteristicas.periodo ) );
            if (periodoGracia > 0) {
                cuotaTotal = this.CalculaCuotaNivelada(
                    monto,
                    tasaAnual,
                    plazo - (periodoGracia*12/caracteristicas.periodo ) ,
                    caracteristicas.periodo,
                    caracteristicas.diasPeriodo,
                );
                console.log("Cuota con gracia", cuotaTotal);
            } else {
                cuotaTotal = this.CalculaCuotaNivelada(
                    monto,
                    tasaAnual,
                    plazo,
                    caracteristicas.periodo,
                    caracteristicas.diasPeriodo,
                );

            }

            // Arreglo plan de pago que se va a imprimir
            this.planPagoToPrint = []
            // Manipulador del DOM para el Plan de Pago
            const tablaBody = document.getElementById('tablaPlanPagos')
            tablaBody.innerHTML = ''


            tablaBody.innerHTML = `
        <tr>
          <th class="text-center align-middle" scope="row">0</td>
          <td class="text-center align-middle">${this.dateFormat(fechaInicial.toISOString().slice(0, 10))}</td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle"></td>
          <td class="text-center align-middle">${Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
          <td class="text-center align-middle">0</td>

        </tr>
      `

            this.planPagoToPrint.push({
                noCuota: 0,
                fechaPago: this.dateFormat(fechaInicial.toISOString().slice(0, 10)),
                cuotaTotal: '',
                interes: '',
                capital: '',
                saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                capitalDT: capitalDT
            })



            if (this.pagosInteres.length > 0) {

                //   LOGICA DE LOS PAGOS DE INTERES COND 1
                for (let i = 0; i < pagosInteres.length; i++) {
                    let condicion = new Date(pagosInteres[i].fecha) < new Date(caracteristicas.fechaApertura.getTime())


                    if (condicion) {


                        tablaBody.innerHTML += `
          <tr class="table-primary">
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(pagosInteres[i].fecha)}</td>
            <td class="text-center align-middle">${Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            </tr>
          `

                        this.planPagoToPrint.push({
                            noCuota: "*Interés",
                            fechaPago: this.dateFormat(pagosInteres[i].fecha),
                            cuotaTotal: Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                            interes: Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                            capital: '',
                            saldo: '',
                            capitalDT: '',
                        })

                    }
                }
                // condicion = new Date(pagosInteres[i].fecha) < new Date(fechaApertura.getTime() + duracionPago)
            }

            // Si no es Credito Agricola y no es Credito Trabajo 2
            if (this.comprobarCrediTrabajo(producto) !== true && producto !== 'Credi Trabajo 2') {

                let cuotaPagar

                let cuotaSeEncuentra = 0

                for (let i = 1; i <= Math.round(caracteristicas.noCuotas); i++) {
                    cuotaSeEncuentra = i
                    interes = ((saldo * tasaAnual) / 360) * caracteristicas.diasPeriodo;
                    //  Si tiene periodo de gracia
                    if (periodoGracia >= 1 && i <= periodoGracia) {
                        capital = 0
                        cuotaPagar = interes
                    } else {
                        capital = cuotaTotal - interes;
                        cuotaPagar = cuotaTotal
                    }
                    saldo = this.convertirANoNegativo(saldo - capital);
                    capitalDT += capital;


                    // Imprimir la fila de la tabla
                    tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(caracteristicas.fechaApertura.toISOString().slice(0, 10))}</td>
            <td class="text-center align-middle">${Number(cuotaPagar).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(capitalDT).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            </tr>
          `
                    this.planPagoToPrint.push({
                        noCuota: i,
                        fechaPago: this.dateFormat(caracteristicas.fechaApertura.toISOString().slice(0, 10)),
                        cuotaTotal: Number(cuotaPagar).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                        interes: Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                        capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                        saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                        capitalDT: Number(capitalDT).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
                    })

                    //   LOGICA DE LOS PAGOS DE INTERES COND 2
                    for (let i = 0; i < pagosInteres.length; i++) {
                        let condicion = false

                        if (cuotaSeEncuentra >= 1) {
                            if (fechaFija) {

                                condicion = new Date(pagosInteres[i].fecha) >= caracteristicas.fechaApertura && new Date(pagosInteres[i].fecha) < new Date(this.sumarMeses(caracteristicas.fechaApertura, caracteristicas.duracionPago))

                            } else {
                                condicion = new Date(pagosInteres[i].fecha) >= caracteristicas.fechaApertura && new Date(pagosInteres[i].fecha) < new Date(caracteristicas.fechaApertura.getTime() + caracteristicas.duracionPago)

                            }
                        }
                        if (cuotaSeEncuentra == Math.round(caracteristicas.noCuotas)) {
                            condicion = new Date(pagosInteres[i].fecha) >= caracteristicas.fechaApertura
                        }

                        if (condicion) {


                            tablaBody.innerHTML += `
          <tr class="table-primary">
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(pagosInteres[i].fecha)}</td>
            <td class="text-center align-middle">${Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle"></td>
            </tr>
          `

                            this.planPagoToPrint.push({
                                noCuota: "*Interés",
                                fechaPago: this.dateFormat(pagosInteres[i].fecha),
                                cuotaTotal:Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                                interes: Number(pagosInteres[i].monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                                capital: '',
                                saldo: '',
                                capitalDT: '',
                            })
                        }
                    }



                    if ((this.esAgricola(producto) && this.limpiarYMinusc(periodoPago) != 'mensual' && this.limpiarYMinusc(periodoPago) != 'semanal' && this.limpiarYMinusc(periodoPago) != 'quincenal') || fechaFija) {

                        caracteristicas.fechaApertura = this.sumarMeses(caracteristicas.fechaApertura, caracteristicas.duracionPago)

                    } else {
                        caracteristicas.fechaApertura = new Date(caracteristicas.fechaApertura.getTime() + caracteristicas.duracionPago);

                    }

                    SumaCuotaTotal += cuotaTotal
                    SumaInteres += interes
                    SumaCapital += capital
                }

            }
            else {

                if (this.creditrabajo2(producto)) {
                    caracteristicas.noCuotas = Math.round(caracteristicas.noCuotas)
                }
                cuotaTotal = monto / caracteristicas.noCuotas;
                for (let i = 1; i <= Math.round(caracteristicas.noCuotas); i++) {
                    interes = ((saldo * tasaAnual) / 360) * caracteristicas.diasPeriodo;
                    capital = cuotaTotal;
                    saldo = this.convertirANoNegativo(saldo - capital);
                    capitalDT += capital
                    // Imprimir la fila de la tabla
                    tablaBody.innerHTML += `
          <tr>
            <th class="text-center align-middle" scope="row">${i}</th>
            <td class="text-center align-middle">${this.dateFormat(caracteristicas.fechaApertura.toISOString().slice(0, 10))}</td>
            <td class="text-center align-middle">${cuotaTotal.toFixed(2)} ${this.moneda}</td>
            <td class="text-center align-middle"></td>
            <td class="text-center align-middle">${capital.toFixed(2)} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            <td class="text-center align-middle">${Number(capitalDT).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</td>
            </tr>
            `
                    this.planPagoToPrint.push({
                        noCuota: i,
                        fechaPago: this.dateFormat(caracteristicas.fechaApertura.toISOString().slice(0, 10)),
                        cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                        interes: '',
                        capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                        saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
                        capitalDT: Number(capitalDT).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
                    })
                    caracteristicas.fechaApertura = new Date(caracteristicas.fechaApertura.getTime() + caracteristicas.duracionPago);

                    SumaCuotaTotal += cuotaTotal
                    SumaInteres += interes
                    SumaCapital += capital
                }
            }


            tablaBody.innerHTML += `
          <tr class="table-success">
            <th class="text-center align-middle" scope="row"></th>
            <td class="text-center align-middle"> <strong> Total </strong></td>
            <td class="text-center align-middle"><strong>${Number(SumaCuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong>${Number(SumaInteres).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong>${Number(SumaCapital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${this.moneda}</strong></td>
            <td class="text-center align-middle"><strong></strong></td>
            <td class="text-center align-middle"><strong></strong></td>
            </tr>
          `

            // this.planPagoToPrint.push({
            //     noCuota: Total,
            //     fechaPago: this.dateFormat(fechaApertura.toISOString().slice(0, 10)),
            //     cuotaTotal: Number(cuotaTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            //     interes: Number(interes).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            //     capital: Number(capital).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda,
            //     saldo: Number(saldo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + this.moneda
            // })

        },
        caracteristicasPeriodoPago(periodoPago, fechaFija, producto, plazo, fechaApertura){
            let duracionPago, noCuotas, periodo, diasPeriodo;

            switch (this.limpiarYMinusc(periodoPago)) {
                case "mensual":

                    if (fechaFija) {
                        duracionPago = 1;
                        fechaApertura = this.sumarMeses(fechaApertura, 1)
                    } else {
                        duracionPago = 30 * 24 * 60 * 60 * 1000;
                        fechaApertura = new Date(
                            fechaApertura.getTime() + 30 * 24 * 60 * 60 * 1000
                        );
                    }
                    noCuotas = plazo;
                    periodo = 12;
                    diasPeriodo = 30.0;
                    break;

                case "quincenal":
                    duracionPago = 15 * 24 * 60 * 60 * 1000;
                    fechaApertura = new Date(
                        fechaApertura.getTime() + 15 * 24 * 60 * 60 * 1000
                    );
                    noCuotas = plazo * 2;
                    periodo = 24;
                    diasPeriodo = 15.0;
                    break;

                case "semanal":
                    duracionPago = 7 * 24 * 60 * 60 * 1000;
                    fechaApertura = new Date(
                        fechaApertura.getTime() + 7 * 24 * 60 * 60 * 1000
                    );
                    if (this.esCrediTrabajo(producto)) {
                        noCuotas = plazo * 4;
                    } else {
                        noCuotas = plazo * (4.3333333333);
                    }

                    periodo = 52.1;
                    diasPeriodo = 7.0;
                    break;
                case "alvencimiento":
                    duracionPago = 1;
                    fechaApertura = new Date(
                        fechaApertura.getTime() + (plazo * 30) * 24 * 60 * 60 * 1000
                    );
                    noCuotas = 1;
                    periodo = (30 / (plazo * 30)) * 12;
                    diasPeriodo = plazo * 30;
                    break;
                case "bimensual":
                    if (this.esAgricola(producto) || fechaFija) {
                        duracionPago = 2;
                        fechaApertura = this.sumarMeses(fechaApertura, 2)
                    } else {
                        duracionPago = 60 * 24 * 60 * 60 * 1000;
                        fechaApertura = new Date(
                            fechaApertura.getTime() + 60 * 24 * 60 * 60 * 1000
                        );
                    }

                    noCuotas = plazo / 2;
                    periodo = 6;
                    diasPeriodo = 60.0;
                    break;
                case "trimestral":
                    if (this.esAgricola(producto) || fechaFija) {
                        duracionPago = 3;
                        fechaApertura = this.sumarMeses(fechaApertura, 3)
                    } else {
                        duracionPago = 90 * 24 * 60 * 60 * 1000;
                        fechaApertura = new Date(
                            fechaApertura.getTime() + 90 * 24 * 60 * 60 * 1000
                        );
                    }

                    noCuotas = plazo / 3;
                    periodo = 4;
                    diasPeriodo = 90.0;
                    break;
                case "semestral":

                    if (this.esAgricola(producto) || fechaFija) {
                        duracionPago = 6;
                        fechaApertura = this.sumarMeses(fechaApertura, 6)
                    } else {
                        duracionPago = 180 * 24 * 60 * 60 * 1000;
                        fechaApertura = new Date(
                            fechaApertura.getTime() + 180 * 24 * 60 * 60 * 1000
                        );
                    }

                    noCuotas = plazo / 6;
                    periodo = 2;
                    diasPeriodo = 180.0;
                    break;
                case "anual":

                    if (this.esAgricola(producto) || fechaFija) {
                        duracionPago = 12;
                        fechaApertura = this.sumarMeses(fechaApertura, 12)
                    } else {
                        duracionPago = 360 * 24 * 60 * 60 * 1000;
                        fechaApertura = new Date(
                            fechaApertura.getTime() + 360 * 24 * 60 * 60 * 1000
                        );
                    }

                    noCuotas = plazo / 12;
                    periodo = 1;
                    diasPeriodo = 360.0;
                    break;

                default:
                    console.log("Periodo de pago no válido");
                    return;
            }

            return { duracionPago, fechaApertura, noCuotas, periodo, diasPeriodo }
        },
        handleImprimirPlanPago() {
            const doc = new jsPDF()

            // const text = 'PLAN DE PAGO';
            // const textWidth = doc.getTextWidth(text);
            // this.agregarTextoCentrado(`Plan de Pago`, 0, 30, doc, 14)
            const text = 'PLAN DE PAGO';
            // const textWidth = doc.getTextWidth(text);
            // const centerX = (doc.internal.pageSize.width - textWidth) / 2;
            let y = 20;
            // var tableHeight

            // Calcula las dimensiones del documento
            const docWidth = doc.internal.pageSize.getWidth();
            // Agrega una imagen al documento
            const img = new Image();
            img.src = require('@/assets/header.png'); // Reemplaza 'mi_imagen.jpg' con el nombre de tu imagen
            // Calcula las dimensiones de la imagen para que ocupe todo el ancho de la página
            const imgWidth = docWidth;
            // const imgHeight = (img.height * imgWidth) / img.width;
            // doc.addImage(img, 'PNG', 10, 10, 300, 200); // Ajusta las coordenadas y el tamaño según tu necesidad
            doc.addImage(img, 'PNG', 0, 0, imgWidth, 30);
            doc.setFontSize(12)
            doc.setTextColor(255, 255, 255);
            doc.text(text, 130, (y - 6));

            // Calcular la posición para centrar el texto
            // const centerX = (doc.internal.pageSize.width - textWidth) / 2;
            y = 30;

            // Texto centrado arriba
            // this.agregarTextoCentrado(`Prueba Plan`, 43, 10, doc, 11);
            doc.setFont('courier');

            // Recolectar datos de tablas HTML
            const tableData = [];
            const tableInfoPrestamo = [];

            document.querySelectorAll('.datos-table tr').forEach((row) => {
                const rowData = [];
                row.querySelectorAll('td').forEach((cell) => rowData.push(cell.innerText));
                tableData.push(rowData);
            });

            document.querySelectorAll('.datos-prestamo-table tr').forEach((row) => {
                const rowData = [];
                row.querySelectorAll('td').forEach((cell) => rowData.push(cell.innerText));
                tableInfoPrestamo.push(rowData);
            });

            this.ejecutarPlanPagos();

            // 🟦 Primera tabla
            doc.autoTable({
                startY: y + 10,
                body: tableData,
                theme: 'striped',
                styles: { halign: 'center' },
            });
            y = doc.lastAutoTable.finalY + 10; // 👈 Actualiza Y después de la primera tabla

            // 🟨 Segunda tabla
            doc.autoTable({
                startY: y,
                body: tableInfoPrestamo,
                theme: 'striped',
                styles: { halign: 'left' },
            });
            y = doc.lastAutoTable.finalY + 10;

            // 🟥 Tercera tabla (Plan de pagos)
            doc.autoTable({
                startY: y,
                head: [['No. Cuota', 'Fecha de Pago', 'Cuota Total', 'Interes', 'Capital', 'Saldo']],
                headStyles: { fillColor: [41, 128, 185] },
                body: this.planPagoToPrint.map(plan => [
                    plan.noCuota, plan.fechaPago, plan.cuotaTotal, plan.interes, plan.capital, plan.saldo
                ]),
                theme: 'grid',
                styles: { halign: 'center' },
            });
            y = doc.lastAutoTable.finalY + 10;
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(10)

            if(this.pagosInteres.length > 0) {
                doc.text("*Corresponde al arreglo del pago de los interes del crédito anterior.", 20, y);
            }   

            // Guardar PDF
            doc.save(`plan-Plan de Pago.pdf`);

        },
        //Convertir string a minuscula y sin espacios
        limpiarYMinusc(string) {
            // Eliminar espacios en blanco y convertir a minúsculas
            return string.replace(/\s/g, '').toLowerCase();
        },
        sumarMeses(fecha, meses) {
            const nuevaFecha = new Date(fecha);
            nuevaFecha.setMonth(nuevaFecha.getMonth() + meses);
            return nuevaFecha;
        },
        esCrediTrabajo(producto) {
            // Convertir producto a minúsculas para normalizar
            producto = producto.trim().toLowerCase();

            // Lista de valores normalizados
            const creditrabajo = [
                "creditrabajo",
                "credi trabajo",
                "credi trabajo ",
                "credi trabajo",
                "Credi Trabajo",
                "creditrabajo ",
                "creditrabajo ",
                "credi trabajo",
                "creditrabajo",
            ];

            // Verificar si el producto está en la lista de valores normalizados
            return creditrabajo.includes(producto);
        },
        creditrabajo2(producto) {
            return producto === 'Credi Trabajo 2'

        },
        comprobarCrediTrabajo(producto) {

            if (producto === 'Credi Trabajo' || producto === 'Credi Trabajo' || producto === 'Creditrabajo ' || producto === 'credi trabajo' || producto === 'CREDI TRABAJO' || producto === 'CREDITRABAJO' || producto === 'creditrabajo' || producto === 'CREDITRABAJO ' || producto === 'creditrabajo ' || producto === 'Creditrabajo ' || producto === 'Credi Trabajo ' || producto === ' Credi trabajo' || producto === 'credi trabajo ' || producto === 'Credi trabajo' || producto === ' credi trabajo') {
                return true
            } else {
                return false
            }
        },
        esAgricola(producto) {
            // Convertir a minúsculas y eliminar espacios
            producto = producto.trim().toLowerCase();

            if (producto === "agricola") {
                console.log("Es agricola");
                return true;
            } else {
                return false;
            }
        },
        // CalculaCuotaNivelada calcula la cuota nivelada de un préstamo
        CalculaCuotaNivelada(
            montoPrestamo,
            tasaInteres,
            periodos,
            periodo,
            diasPeriodo
        ) {
            if (periodo === 24) {
                periodos *= 2;
            } else if (periodo === 52.1) {
                periodos *= 4.33;
                periodos = Math.round(periodos);
            } else if (periodo === (30 / (periodos * 30)) * 12) {
                periodos = 1
            } else if (periodo === 6) {
                periodos /= 2;
                // periodos = Math.round(periodos);
            } else if (periodo === 4) {
                periodos /= 3;
                // periodos = Math.round(periodos);
            } else if (periodo === 2) {
                periodos /= 6;
                // periodos = Math.round(periodos);
            } else if (periodo === 1) {
                periodos /= 12;
                // periodos = Math.round(periodos);
            }

            let tasaMensual = (tasaInteres / 360) * diasPeriodo;
            tasaMensual = Math.round(tasaMensual * 10000000000) / 10000000000;

            let cuota =
                (montoPrestamo * tasaMensual) / (1 - Math.pow(1 + tasaMensual, -periodos));
            return cuota;
        },
        //Convertir numero negativo a 0
        convertirANoNegativo(numero) {
            // Si el número es negativo, convertirlo a cero
            if (numero < 0) {
                return 0;
            } else {
                return numero;
            }
        },
        stringToDate(dateString) {
            // Cadena con formato mm/dd/yyyy
            // Diseño que coincide con el formato de la cadena
            let date = new Date(dateString.split("/").join("-").slice(0, 10));
            date.toLocaleDateString("es-ES", { year: 'numeric', month: '2-digit', day: '2-digit' })
            return date;
        },
        dateFormat(param) {

            var fechaISO = param;

            // Crear un objeto Date con la fecha proporcionada
            var fecha = new Date(fechaISO);

            // Obtener el día del mes (agregando un cero inicial si es necesario)
            var dia = ('0' + fecha.getUTCDate()).slice(-2);

            // Obtener el mes (agregando un cero inicial si es necesario)
            var mes = ('0' + (fecha.getUTCMonth() + 1)).slice(-2);

            // Obtener el año
            var anio = fecha.getUTCFullYear();

            // Formatear la fecha según tus necesidades
            var fechaFormateada = dia + '/' + mes + '/' + anio;


            return fechaFormateada;

        },
        agregarTextoCentrado(text, ancho, altura, doc, fontSize) {
            doc.setFontSize(fontSize);

            const textWidth = doc.getTextWidth(text);
            // // Calcular la posición para centrar el texto

            const centerX = (doc.internal.pageSize.width - textWidth) / 2;
            const y = 10;


            // // Colocar el texto centrado
            doc.text(text, centerX + ancho, y + altura);
        },
        filaPlanPago() {

        },
    }
}
</script>

<style scoped>
/* .modal-dialog{
    margin: 20px !important
} */

 
</style>

<style>
.btn-plan-pago {
    color: white;
    margin-bottom: 0 !important;

}

.btn-plan-pago:hover {
    color: white;
}

.btn-plan-pago:active {
    color: white;
}

.btn-plan-pago:focus {
    color: white;
}

button {

    margin: 0px;
}


</style>
